import React from 'react'

const CloseButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="#949494"
    >
      <g>
        <g>
          <g transform="rotate(45 8.5 8.5)">
            <path d="M17.067 7H-.067C-1.133 7-2 7.673-2 8.5S-1.133 10-.067 10h17.134C18.133 10 19 9.327 19 8.5S18.133 7 17.067 7z" />
          </g>
          <g transform="rotate(-45 8.5 8.5)">
            <path d="M17.067 7H-.067C-1.133 7-2 7.673-2 8.5S-1.133 10-.067 10h17.134C18.133 10 19 9.327 19 8.5S18.133 7 17.067 7z" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default CloseButton
